<template>
	<div>
		<common-table :table-columns="tableColumns" :url="url" :operate="operate" :searchs="searchs"
			:form-fields="formFields" :permission="permission" pageName="AdDailyOverallReport" />
	</div>
</template>

<script>
import CommonTable from "@/components/CommonTable/CommonTable";

const ONE_DAY_MS = 24 * 60 * 60 * 1000;

function parseDateTime(value) {
	if (!value) {
		return null;
	}
	if (value instanceof Date) {
		return isNaN(value.getTime()) ? null : value;
	}
	if (typeof value === 'number') {
		const date = new Date(value);
		return isNaN(date.getTime()) ? null : date;
	}
	if (typeof value === 'string') {
		const normalizedValue = value.includes('T') ? value : value.replace(/-/g, '/');
		const date = new Date(normalizedValue);
		return isNaN(date.getTime()) ? null : date;
	}
	const date = new Date(value);
	return isNaN(date.getTime()) ? null : date;
}

function formatReportDate(value) {
	const date = parseDateTime(value);
	if (!date) {
		return value || '-';
	}
	const reportDate = new Date(date.getTime() - ONE_DAY_MS);
	const year = reportDate.getFullYear();
	const month = String(reportDate.getMonth() + 1).padStart(2, '0');
	const day = String(reportDate.getDate()).padStart(2, '0');
	return `${year}-${month}-${day}`;
}

export default {
	name: 'AdDailyOverallReport',
	components: { CommonTable },
	data() {
		return {
			searchs: [{
				name: 'agentId',
				placeholder: '代理',
				type: 'select',
				selectUrl: '/agent/getAll',
				selectData: [],
			}],
			permission: {
				add: 'adDailyOverallReport:add',
				update: 'adDailyOverallReport:update',
				delete: 'adDailyOverallReport:delete',
				deleteBatch: 'adDailyOverallReport:deleteBatch'
			},
			url: {
				get: '/adDailyOverallReport/listByCondition',
				add: '/adDailyOverallReport/add',
				update: '/adDailyOverallReport/update',
				delete: '/adDailyOverallReport/delete',
				delete_batch: '/adDailyOverallReport/deleteBatch',
				status: '/adDailyOverallReport/status',
			},
			tableColumns: [{
				field: 'id',
				label: 'Id',
				show: true,
				width: '100',
			},
        {
          field: 'agentId',
          label: '代理',
          selectUrl: '/agent/getAll',
          selectData: [],
          show: {
            type: 'select',
          },
        }, {
				field: 'dailyCreateCount',  // 字段名
				label: '总创建任务数',  // 字段显示名称
				sort: false,  // 是否排序
				show: true,  // 是否展示
			}, {
				field: 'totalConsumption',  // 字段名
				label: '总消耗量',  // 字段显示名称
				sort: false,  // 是否排序
				show: true,  // 是否展示
			}, {
				field: 'totalOrderNum',  // 字段名
				label: '总订单数',  // 字段显示名称
				sort: false,  // 是否排序
				show: true,  // 是否展示
			}, {
				field: 'totalAmount',  // 字段名
				label: '总成单金额',  // 字段显示名称
				sort: false,  // 是否排序
				show: true,  // 是否展示
			}, {
				field: 'avgRoi',  // 字段名
				label: 'ROI',  // 字段显示名称
				sort: false,  // 是否排序
				show: true,  // 是否展示
			},
			{
				field: 'createTime',
				label: '时间',
				show: true,
				width: '',
				formatter: (row) => formatReportDate(row.createTime),
			}

			],
			formFields: {
				addTitle: '添加',
				updateTitle: '修改',
				model: [
					{
						field: 'id',  // 字段名
						label: 'ID',  // 字段显示名称
						type: 'input',
						add: false,  // 是否添加
						update: true
					},
					{
						field: 'agentId',  // 字段名
						label: 'agentId',  // 字段显示名称
						type: 'input',
						placeholder: '请输入agentId',
						rules: [
							{ required: true, message: 'agentId不能为空', trigger: 'blur' }
						],
						add: true,
						update: true,
					}, {
						field: 'dailyCreateCount',  // 字段名
						label: 'dailyCreateCount',  // 字段显示名称
						type: 'input',
						placeholder: '请输入dailyCreateCount',
						rules: [
							{ required: true, message: 'dailyCreateCount不能为空', trigger: 'blur' }
						],
						add: true,
						update: true,
					}, {
						field: 'totalConsumption',  // 字段名
						label: 'totalConsumption',  // 字段显示名称
						type: 'input',
						placeholder: '请输入totalConsumption',
						rules: [
							{ required: true, message: 'totalConsumption不能为空', trigger: 'blur' }
						],
						add: true,
						update: true,
					}, {
						field: 'totalOrderNum',  // 字段名
						label: 'totalOrderNum',  // 字段显示名称
						type: 'input',
						placeholder: '请输入totalOrderNum',
						rules: [
							{ required: true, message: 'totalOrderNum不能为空', trigger: 'blur' }
						],
						add: true,
						update: true,
					}, {
						field: 'totalAmount',  // 字段名
						label: 'totalAmount',  // 字段显示名称
						type: 'input',
						placeholder: '请输入totalAmount',
						rules: [
							{ required: true, message: 'totalAmount不能为空', trigger: 'blur' }
						],
						add: true,
						update: true,
					}, {
						field: 'avgRoi',  // 字段名
						label: 'avgRoi',  // 字段显示名称
						type: 'input',
						placeholder: '请输入avgRoi',
						rules: [
							{ required: true, message: 'avgRoi不能为空', trigger: 'blur' }
						],
						add: true,
						update: true,
					},
				]
			},
			operate: [{
				icon: 'el-icon-edit',
				type: 'text',
				text: '查看详情',
				handle: (row) => {
					console.log(row)
					this.$router.push({
						path: '/qdd/admin/AdDailyAccountReport.html',
						query: {
							id: row.id,
							getLog: true
						}
					})

				}
			}]
		}
	}
}
</script>

<style scoped></style>
